var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-form",
        {
          staticStyle: { background: "white" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _vm.places.length > 0
            ? [
                _c(
                  "ul",
                  { staticClass: "place-inputs" },
                  [
                    _c(
                      "draggable",
                      {
                        attrs: { handle: ".reorder-handle" },
                        on: {
                          end: function($event) {
                            return _vm.onReordered()
                          }
                        },
                        model: {
                          value: _vm.places,
                          callback: function($$v) {
                            _vm.places = $$v
                          },
                          expression: "places"
                        }
                      },
                      _vm._l(_vm.places, function(place, index) {
                        var _obj
                        return _c(
                          "li",
                          { key: index },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "" } },
                              [
                                _vm.$store.getters.mode ===
                                  _vm.constants.modes.isochrones &&
                                _vm.places.length > 1
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs1: "" } },
                                      [
                                        _c(
                                          "v-icon",
                                          { staticClass: "reorder-handle" },
                                          [_vm._v("reorder")]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  _vm._b(
                                    {},
                                    "v-flex",
                                    ((_obj = {}),
                                    (_obj[
                                      _vm.$store.getters.mode ===
                                      _vm.constants.modes.directions
                                        ? "xs11"
                                        : "xs12"
                                    ] = true),
                                    _obj),
                                    false
                                  ),
                                  [
                                    _c("place-input", {
                                      ref: "place" + index,
                                      refInFor: true,
                                      attrs: {
                                        "id-postfix": "isochrones",
                                        "support-directions": false,
                                        "support-search": false,
                                        box: _vm.places.length === 1,
                                        index: index,
                                        model: _vm.places[index],
                                        "pick-place-supported": "",
                                        single: _vm.places.length === 1,
                                        "is-last":
                                          _vm.places.length - 1 === index &&
                                          index !== 0
                                      },
                                      on: {
                                        selected: _vm.selectPlace,
                                        removeInput: _vm.removePlaceInput,
                                        addInput: _vm.addPlaceInput,
                                        cleared: _vm.placeCleared
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "form-actions-btns", attrs: { row: "" } },
            [
              _c("form-actions", {
                attrs: {
                  "place-inputs": _vm.places.length,
                  "disabled-actions": _vm.disabledActions
                },
                on: {
                  addPlaceInput: _vm.addPlaceInput,
                  clearPlaces: _vm.clearPlaces,
                  reverseRoute: _vm.reverseRoute,
                  contentUploaded: _vm.contentUploaded
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.mapViewData
            ? [
                _vm.mapViewData && _vm.mapViewData.hasPlaces()
                  ? _c("ischrones-details", {
                      attrs: { "map-view-data": _vm.mapViewData }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("br")
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.getters.mode === _vm.constants.modes.isochrones
            ? _c(
                "box",
                { attrs: { background: "white", "no-shadow": "" } },
                [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("global.parameters")))])
                  ]),
                  _vm._v(" "),
                  _c("fields-container", {
                    attrs: { parameters: _vm.OrsMapFiltersAccessor },
                    on: { fieldUpdated: _vm.filterUpdated }
                  }),
                  _vm._v(" "),
                  _c("br")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("br")
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2350d91b", { render: render, staticRenderFns: staticRenderFns })
  }
}